import { Model, Attr, BelongsTo, HasMany } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import Media from './Media';
import moment from 'moment';

@Model()
export default class Auction extends ApplicationRecord {
  static jsonapiType = 'auctions';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
      },
      {
        text: 'Code',
        value: 'code',
      },
      {
        text: 'Title',
        value: 'title',
      },
      {
        text: 'Created',
        value: 'created',
        width: 180,
      },
      {
        text: 'Visibility',
        value: 'published',
        width: 100,
        align: 'center',
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return Auction.includes(['images']);
  }

  static defaultOptions() {
    return {
      sortBy: ['created'],
      sortDesc: [true],
    };
  }

  @Attr() created: string;
  @Attr() title: string;
  @Attr() date: string;
  @Attr() bidsCloseAt: string;
  @Attr() status: string = 'future';
  @Attr() code: string;
  @Attr() description: string;
  @Attr() published: string | null;
  @Attr() lastExport: string;
  @Attr() lastBidExport: string;
  @Attr() lastBidderExport: string;

  @HasMany() images: Media[];

  get formattedDate() {
    if (!this.created) {
      return;
    }
    return moment(this.created).format('MMM D, YYYY h:mm a');
  }
}
